// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-2KTLC";
var _3 = "content-1UNKe";
var _4 = "center-2wFW5";
var _5 = "start-3ua5G";
var _6 = "end-1RY4J";
var _7 = "ellipsis-2z08p";
var _8 = "aircraft-2DP7W";
var _9 = "flightInfo-39Ng3";
var _a = "raceNumber-2nTH9";
var _b = "flightStatus-2R9rh";
var _c = "routes-3fR-9";
var _d = "text_left-395Qz";
var _e = "text_right-1W3mc";
var _f = "routeInfo-3b32X";
var _10 = "icon-1wrDH";
var _11 = "departure-3Etxk";
var _12 = "text_light-2mVIc";
export { _1 as "__esModule", _2 as "container", _3 as "content", _4 as "center", _5 as "start", _6 as "end", _7 as "ellipsis", _8 as "aircraft", _9 as "flightInfo", _a as "raceNumber", _b as "flightStatus", _c as "routes", _d as "text_left", _e as "text_right", _f as "routeInfo", _10 as "icon", _11 as "departure", _12 as "text_light" }
export default { "__esModule": _1, "container": _2, "content": _3, "center": _4, "start": _5, "end": _6, "ellipsis": _7, "aircraft": _8, "flightInfo": _9, "raceNumber": _a, "flightStatus": _b, "routes": _c, "text_left": _d, "text_right": _e, "routeInfo": _f, "icon": _10, "departure": _11, "text_light": _12 }
